var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgResourceArticles = function SvgResourceArticles(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 18"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M4.5 16.5A1.5 1.5 0 0 1 3 15V3a1.5 1.5 0 0 1 1.5-1.5h6a1.8 1.8 0 0 1 1.279.529l2.69 2.69A1.8 1.8 0 0 1 15.002 6v9a1.5 1.5 0 0 1-1.5 1.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M10.5 1.5v3.75a.75.75 0 0 0 .75.75H15M7.5 6.75H6M12 9.75H6M12 12.75H6"
  })));
};
export default SvgResourceArticles;